import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';
import { ColorPickerDropdown } from '@givebutter/primitives/color-picker';
import { FormField } from './FormField';

interface FormColorPickerProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  description?: string;
  disabled?: boolean;
}

export const FormColorPicker = <T extends FieldValues>({
  name,
  control,
  label,
  description,
  disabled,
}: FormColorPickerProps<T>) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FormField label={label} htmlFor={name} description={description} error={error?.message}>
      <ColorPickerDropdown
        value={value ?? ''}
        onValueChange={color => onChange(color)}
        disabled={disabled}
        contentClassName="w-(--radix-popover-trigger-width)"
      />
    </FormField>
  );
};
